// @flow
import Tooltip from 'material-ui/Tooltip';
import React from 'react';

type Props = {};

export default function KPI({ kpi }: Props) {
    let trend = null;
    if (kpi.trend) {
        let img = null;
        if (kpi.trend.imagePath) {
            img = (
                <img
                    className="trend-icon"
                    src={kpi.trend.imagePath}
                    alt="trendIcon"
                />
            );
        }

        trend = (
            <span className="trend">
                {kpi.trend.title}
                {img}
            </span>
        );
    }

    return (
        <div className="kpi">
            {kpi.imagePath ? <img src={kpi.imagePath} alt="kpiIcon" /> : null}
            <span className="value">{kpi.value}</span>
            {trend}
            <Tooltip
                disableFocusListener
                disableTouchListener
                disableHoverListener={!kpi.subtitle}
                title={kpi.subtitle}
                placement="right"
            >
                <div>
                    <span className="title">{kpi.title}</span>
                    {kpi.subtitle ? (
                        <i className="mdi mdi-information-outline" />
                    ) : null}
                </div>
            </Tooltip>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/view/analytics/KPI.jsx